/*
 * サブシステム名：
 * 機能名：作業明細一覧
 */

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import indexeddb from '@/ddv2.library/indexeddb'

import header from '@/ddv2.library/header'
import date from '@/ddv2.library/date'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'VwCD2plmd0030',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    page: 1,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    headersHacchusakiList: header.mstHacchakuchiHeaders,
    modeKengen: 0
  }),
  components: {
    DdSubHeader,
    DdDateBox,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.dispSagyoEigyosho = elem.sagyoEigyoshoCd ? elem.sagyoEigyoshoCd + ' : ' + elem.sagyoEigyoshoNm : ''
        elem.dispSagyoYoteiYmd = filter.dateFormatter(elem.sagyoYoteiYmd)
        elem.dispTokuisaki = elem.tokuisakiCd ? elem.tokuisakiCd + ' : ' + elem.tokuisakiNm : ''
        elem.dispHinmei = elem.hinmeiCd ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.juchuSuryo = elem.juchuSuryo ? filter.numericFormatter(elem.juchuSuryo) : ''
        elem.juchuJuryo = elem.juchuJuryo ? filter.numericFormatter(elem.juchuJuryo) : ''
        elem.tanka = elem.tanka ? filter.numericFormatter(elem.tanka) : ''
        elem.dispHatsuchi = elem.hatsuchiCd ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.dispHatsuchiHms = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.dispKeiyuchi1 = elem.keiyuchi1Cd ? elem.keiyuchi1Cd + ' : ' + elem.keiyuchi1Nm : elem.keiyuchiId1Biko
        elem.dispKeiyuchi2 = elem.keiyuchi2Cd ? elem.keiyuchi2Cd + ' : ' + elem.keiyuchi2Nm : elem.keiyuchiId2Biko
        elem.dispKeiyuchi3 = elem.keiyuchi3Cd ? elem.keiyuchi3Cd + ' : ' + elem.keiyuchi3Nm : elem.keiyuchiId3Biko
        elem.dispKeiyuchi4 = elem.keiyuchi4Cd ? elem.keiyuchi4Cd + ' : ' + elem.keiyuchi4Nm : elem.keiyuchiId4Biko
        elem.dispKeiyuchi5 = elem.keiyuchi5Cd ? elem.keiyuchi5Cd + ' : ' + elem.keiyuchi5Nm : elem.keiyuchiId5Biko
        elem.dispChakuchi = elem.chakuchiCd ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.dispChakuchiHms = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyori = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) : ''
        elem.kihonUnchin = elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : ''
        elem.jikanWarimashiKingaku = elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : ''
        elem.kyoriWarimashiKingaku = elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : ''
        elem.hiwayPrice = elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : ''
        elem.userKingakuKazei1 = elem.userKingakuKazei1 ? filter.numericFormatter(elem.userKingakuKazei1) : ''
        elem.userKingakuKazei2 = elem.userKingakuKazei2 ? filter.numericFormatter(elem.userKingakuKazei2) : ''
        elem.userKingakuKazei3 = elem.userKingakuKazei3 ? filter.numericFormatter(elem.userKingakuKazei3) : ''
        elem.userKingakuKazei4 = elem.userKingakuKazei4 ? filter.numericFormatter(elem.userKingakuKazei4) : ''
        elem.userKingakuHikazei1 = elem.userKingakuHikazei1 ? filter.numericFormatter(elem.userKingakuHikazei1) : ''
        elem.userKingakuHikazei2 = elem.userKingakuHikazei2 ? filter.numericFormatter(elem.userKingakuHikazei2) : ''
        elem.sharyoKeihiHiwayEtc = elem.sharyoKeihiHiwayEtc ? filter.numericFormatter(elem.sharyoKeihiHiwayEtc) : ''
        elem.sharyoKeihiHiwayGenkin = elem.sharyoKeihiHiwayGenkin ? filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) : ''
        elem.sharyoKeihiFerry = elem.sharyoKeihiFerry ? filter.numericFormatter(elem.sharyoKeihiFerry) : ''
        elem.sharyoKeihiEtc1 = elem.sharyoKeihiEtc1 ? filter.numericFormatter(elem.sharyoKeihiEtc1) : ''
        elem.sagyoinTeateKingaku1 = elem.sagyoinTeateKingaku1 ? filter.numericFormatter(elem.sagyoinTeateKingaku1) : ''
        return elem
      })
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 品名マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'msthinmei', 'msthacchakuchi'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstHinmeiList.defineHeaderPromise')
            self.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '作業明細No', value: 'sagyoMeisaiNo' },
              /*
              { text: '受注紐づき有', value: 'dispJuchuHimoduki', align: 'center' },
              { text: '実績紐づき有', value: 'dispJissekiHimoduki', align: 'center' },
              */
              { text: '作業営業所', value: 'dispSagyoEigyosho' },
              { text: '作業予定日', value: 'dispSagyoYoteiYmd' },
              { text: '得意先', value: 'dispTokuisaki' },
              { text: '品名', value: 'dispHinmei' },
              { text: '数量', value: 'juchuSuryo' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '重量', value: 'juchuJuryo' },
              { text: '単価', value: 'tanka' },
              { text: '発地', value: 'dispHatsuchi' },
              { text: '発地時刻', value: 'dispHatsuchiHms' },
              { text: '経由地１', value: 'dispKeiyuchi1' },
              { text: '経由地２', value: 'dispKeiyuchi2' },
              { text: '経由地３', value: 'dispKeiyuchi3' },
              { text: '経由地４', value: 'dispKeiyuchi4' },
              { text: '経由地５', value: 'dispKeiyuchi5' },
              { text: '着地', value: 'dispChakuchi' },
              { text: '着地時刻', value: 'dispChakuchiHms' },
              { text: '往復種別', value: 'ohfukuSbtNm' },
              { text: '作業中止', value: 'dispSagyoCancelFlg', align: 'center' },
              { text: '作業中止理由', value: 'sagyoCancelRiyuNm' },
              { text: '作業時間', value: 'yoteiSagyoJikan', align: 'center' },
              { text: '作業距離', value: 'yoteiSokoKyori', align: 'end' },
              { text: '運賃', value: 'kihonUnchin', align: 'end' },
              { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
              { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
              { text: '運賃(高速)', value: 'hiwayPrice', align: 'end' },
              { text: '運賃(他)', value: 'userKingakuKazei1', align: 'end' },
              { text: '割増その他', value: 'userKingakuKazei2', align: 'end' },
              { text: '荷役料', value: 'userKingakuKazei3', align: 'end' },
              { text: '保管料', value: 'userKingakuKazei4', align: 'end' },
              { text: '運賃他(非)', value: 'userKingakuHikazei1', align: 'end' },
              { text: '立替金(非)', value: 'userKingakuHikazei2', align: 'end' },
              { text: '高速ETC', value: 'sharyoKeihiHiwayEtc', align: 'end' },
              { text: '高速現金', value: 'sharyoKeihiHiwayGenkin' },
              { text: 'フェリー', value: 'sharyoKeihiFerry', align: 'end' },
              // { text: '社内傭車', value: 'sharyoKeihiEtc1', align: 'end' },
              { text: '運行手当', value: 'sagyoinTeateKingaku1', align: 'end' },
              { text: '連絡備考', value: 'renrakuBiko' },
              { text: '作業明細備考', value: 'sagyoMeisaiBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstHinmeiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstHinmeiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstHinmeiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstHinmeiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstHinmeiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const today = filter.dateFormatter(new Date())
      const d = new Date()
      const initConditions = {
        sagyoEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, today).id : null,
        sagyoYoteiYmdFrom: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        sagyoYoteiYmdTo: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        tokuisakiId: null,
        mstHinmeiId: null,
        hatsuchiId: null,
        chakuchiId: null
      }
      this.conditions = Object.assign({}, initConditions)
      this.searchText = ''
      this.rows = []
    },
    onSearchButtonClick: function (e) {
      const self = this

      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plmd0030/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .post('/api/v1/VwCD2plmd0030/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '作業明細一覧_' + ts + '.csv'
          elem.click()
          this.Effects.loadComplete()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
